import AddFeedbackTech from "./AddFeedbackTech";

const EditInvFeedbackTech = () => {
  return <AddFeedbackTech isEdit={true} />;
};

export default EditInvFeedbackTech;
